module.exports = __webpack_public_path__ + "static/media/photo44.e35ded21.jpg";